export default "/images/vendor/flag-icons/flags/4x3/sb.svg?c2672e369471d01fcd1cd1ca9bb9af77";